import { lazy } from 'react';
/** Открывает карточку адреса клиента */
export const ClientAddressDetailsPageAsync = lazy(() => import('./ClientAddressDetails/ClientAddressDetailsPage'));